var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 18C33 20.3869 32.0518 22.6761 30.364 24.364C28.6761 26.0518 26.3869 27 24 27C21.6131 27 19.3239 26.0518 17.636 24.364C15.9482 22.6761 15 20.3869 15 18C15 15.6131 15.9482 13.3239 17.636 11.636C19.3239 9.94821 21.6131 9 24 9C26.3869 9 28.6761 9.94821 30.364 11.636C32.0518 13.3239 33 15.6131 33 18Z",
    fill: "#799AA9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24ZM24 3C20.0453 3.00021 16.1711 4.11709 12.8232 6.22208C9.47532 8.32708 6.78985 11.3346 5.07589 14.8986C3.36194 18.4625 2.68916 22.438 3.135 26.3675C3.58083 30.2969 5.12716 34.0206 7.596 37.11C9.726 33.678 14.415 30 24 30C33.585 30 38.271 33.675 40.404 37.11C42.8728 34.0206 44.4192 30.2969 44.865 26.3675C45.3108 22.438 44.6381 18.4625 42.9241 14.8986C41.2102 11.3346 38.5247 8.32708 35.1768 6.22208C31.8289 4.11709 27.9547 3.00021 24 3Z",
    fill: "#799AA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/Person.062b5e209ac570240af236a8b77c727c.svg";
export { ForwardRef as ReactComponent };